import { createContext, useContext, useState } from "preact/compat";
import useAddToCart from "@/hooks/useAddToCart";

export const AddToCartButtonContext = createContext();

function AddToCartButton({ product, quantity, classes='btn-primary-outline', weight, children, onFinish }) {
	const { handleAddToCart, status, setStatus } = useAddToCart();

	const handleAddToCartWithCallback = (event) => {
		handleAddToCart(event, product, quantity, weight);
		if (typeof onFinish === 'function') {
			onFinish();
		}
	};

	return (
		<AddToCartButtonContext.Provider value={{ status, setStatus }}>
			<button 
			type="button" 
			onClick={(event) => handleAddToCartWithCallback(event)} 
			className={`${classes} btn-add-to-cart`}
			disabled={status ==='loading' ? true : false}
			>
				{children}
			</button>
		</AddToCartButtonContext.Provider>
	);
}

function Label({ children }) {
	const { status } = useContext(AddToCartButtonContext);
	let labelText;
	let funLoadingMessages = [
		'Getting the munchies...',
		'Rolling up...',
		'Packing the bowl...',
		'Loading...',
		'Daydreaming...',
	];

	if ( status === 'loading' ) {
		labelText = <span className="adding-text">{funLoadingMessages[Math.floor(Math.random() * funLoadingMessages.length)]}</span>
	} else {
		labelText = children;
	}

	return (
		<>{labelText}</>
	);
}

AddToCartButton.Label = Label;
export default AddToCartButton;